import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["card", "input", "submit"]

  declare readonly cardTargets: HTMLElement[]
  declare readonly inputTarget: HTMLInputElement
  declare readonly submitTarget: HTMLButtonElement
  declare readonly hasSubmitTarget: boolean
  declare readonly hasInputTarget: boolean

  connect(): void {
    // 입력 폼인 경우 submit 버튼 초기 비활성화
    if (this.hasSubmitTarget && this.hasInputTarget) {
      this.submitTarget.disabled = true
    }
  }

  selectCard(event: Event): void {
    // 선택 애니메이션
    this.cardTargets.forEach(card => {
      card.classList.remove("ring-4", "ring-yellow-400", "scale-110")
    })
    const target = event.currentTarget as HTMLElement
    target.classList.add("ring-4", "ring-yellow-400", "scale-110")
  }

  validateInput(): void {
    if (this.hasInputTarget && this.hasSubmitTarget) {
      const value = this.inputTarget.value.trim()
      this.submitTarget.disabled = value.length === 0
    }
  }
}
